"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _find = require("lodash/find");

var _find2 = _interopRequireDefault(_find);

var _map = require("lodash/map");

var _map2 = _interopRequireDefault(_map);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALACARTE = "ALACARTE";

var defaultState = {
    saveCard: true,
    purchaseTypes: [{
        type: "pro",
        period: "yearly",
        price: "39.99",
        text: "Yearly Subscription",
        description: "You will be charged now and yearly at this time when your account automatically renews. Cancel automatic renewal at any time."
    }, {
        type: "pro",
        period: "monthly",
        price: "9.99",
        text: "Monthly Subscription",
        description: "You will be charged now and monthly at this time when your account automatically renews. Cancel automatic renewal at any time."
    }, {
        type: "alacarte",
        price: "1.99",
        text: "One icon",
        description: "​​Purchasing a single license gives you a perpetual, non-exclusive right to use this icon as many times as you wish, without having to credit the icon’s creator."
    }]
};

defaultState.purchaseTypes = (0, _map2.default)(defaultState.purchaseTypes, function (t) {
    if (t.period) {
        t.key = t.type + "." + t.period;
    } else {
        t.key = "" + t.type;
    }
    return t;
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var processing = state.processing;


    switch (action.type) {
        case "DOWNLOAD_ENTER_PHASE_PAYMENT":
        case actionTypes.DOWNLOAD_SELECT_PURCHASE_TYPE:
            {
                var purchaseTypeKey = action.purchaseTypeKey;
                var purchaseTypes = state.purchaseTypes;

                var currentPurchase = (0, _find2.default)(purchaseTypes, function (type) {
                    return type.key == purchaseTypeKey;
                });
                if (!currentPurchase) {
                    console.warn(purchaseTypeKey, "not found");
                }

                if (processing) {
                    return state;
                }

                return _extends({}, state, {
                    currentPurchase: currentPurchase
                });
            }
        case actionTypes.DOWNLOAD_FLOW_GO_BACK:
            {
                var error = null;
                return _extends({}, state, {
                    error: error
                });
            }
        case actionTypes.STRIPE_CARD_INPUT_ERROR:
            {
                var _error = action.error;

                return _extends({}, state, {
                    error: _error
                });
            }
        case actionTypes.STRIPE_CARD_INPUT_CHANGE:
            {
                return _extends({}, state, {
                    error: null
                });
            }
        case actionTypes.STRIPE_SAVE_CARD_CHANGE:
            {
                if (processing) {
                    return state;
                }

                var value = action.value;

                return _extends({}, state, {
                    saveCard: value
                });
            }
        case actionTypes.STRIPE_GET_SAVED_CARD_SUCCESS:
            {
                var savedCard = action.response;
                if (!savedCard.ok) {
                    return _extends({}, state, {
                        savedCard: null
                    });
                }

                return _extends({}, state, {
                    savedCard: savedCard
                });
            }
        case actionTypes.STRIPE_USE_NEW_CARD:
            {
                if (processing) {
                    return state;
                }

                var useNewCard = state.useNewCard;

                var saveCard = false;

                return _extends({}, state, {
                    error: null,
                    useNewCard: !useNewCard,
                    saveCard: saveCard
                });
            }
        case actionTypes.SAVE_CARD:
            {
                return _extends({}, state, {
                    processing: true,
                    error: null
                });
            }
        case actionTypes.SAVE_CARD_SUCCESS:
            {
                return _extends({}, state, {
                    processing: false,
                    useNewCard: false
                });
            }
        case actionTypes.SAVE_CARD_FAILURE:
            {
                var _error2 = action.error;


                var message = (0, _get2.default)(_error2, "error.message") || (0, _get2.default)(_error2, "errors.error.message") || "Something went wrong while trying to save your new card.";

                return _extends({}, state, {
                    processing: false,
                    error: message
                });
            }
        case actionTypes.STRIPE_UPDATE_BILLING_INFO:
            {
                if (processing) {
                    return state;
                }

                var _value = action.value;


                return _extends({}, state, {
                    billingInfo: _value
                });
            }
        case actionTypes.DOWNLOAD_RESET_FLOW:
            {
                var _currentPurchase = null;
                var billingInfo = null;

                return _extends({}, state, {
                    currentPurchase: _currentPurchase,
                    billingInfo: billingInfo
                });
            }

        default:
            return state;
    }
};